const loadedScripts = new Map();
const loadedStyles = new Set();

/**
 * Dynamically loads an external CSS stylesheet if not already added.
 */
export function loadStyle(url, id) {
  if (typeof document === 'undefined') return;
  if (id && document.getElementById(id)) return;
  if (loadedStyles.has(url)) return;
  const link = document.createElement('link');
  if (id) link.id = id;
  link.rel = 'stylesheet';
  link.href = url;
  link.crossOrigin = '';
  document.head.appendChild(link);
  loadedStyles.add(url);
}

/**
 * Dynamically loads an external JS script if not already present on window.
 * Returns a Promise that resolves when the script is loaded and ready.
 */
export function loadScript(url, globalName) {
  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }
  if (globalName && window[globalName]) {
    return Promise.resolve(window[globalName]);
  }
  if (loadedScripts.has(url)) {
    return loadedScripts.get(url);
  }
  const promise = new Promise((resolve, reject) => {
    // If already in DOM
    if (globalName && window[globalName]) {
      resolve(window[globalName]);
      return;
    }
    const existing = document.querySelector("script[src=\"".concat(url, "\"]"));
    if (existing) {
      existing.addEventListener('load', () => resolve(globalName ? window[globalName] : true));
      existing.addEventListener('error', e => reject(e));
      return;
    }
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.crossOrigin = '';
    script.onload = () => {
      resolve(globalName ? window[globalName] : true);
    };
    script.onerror = err => {
      loadedScripts.delete(url);
      reject(new Error("Failed to load script: ".concat(url)));
    };
    document.head.appendChild(script);
  });
  loadedScripts.set(url, promise);
  return promise;
}
export function loadLeaflet() {
  loadStyle('https://unpkg.com/leaflet@1.9.4/dist/leaflet.css', 'leaflet-css');
  return loadScript('https://unpkg.com/leaflet@1.9.4/dist/leaflet.js', 'L');
}
export function loadApexCharts() {
  return loadScript('https://cdn.jsdelivr.net/npm/apexcharts@3.54.1/dist/apexcharts.min.js', 'ApexCharts');
}
flarum.reg.add('nagusi-match-ratings', 'forum/common/lazyAssetLoader', { loadStyle: loadStyle,loadScript: loadScript,loadLeaflet: loadLeaflet,loadApexCharts: loadApexCharts, });